import { createRouter, createWebHistory } from "vue-router";
import DefaultLayout from "@/components/layouts/DefaultLayout.vue"

import HomeView from "@/components/views/HomeView.vue";
import AboutUsView from "@/components/views/AboutUsView.vue";
import VisionMissionView from "@/components/views/VisionMissionView.vue";
import OurServicesView from "@/components/views/OurServicesView.vue";
import ServicesDetailsView from "@/components/views/ServicesDetailsView.vue";
import ServicesSubCategoryDetailsView from "@/components/views/ServicesSubCategoryDetailsView.vue";
import NewsView from "@/components/views/NewsView.vue";
import ProjectsView from "@/components/views/ProjectsView.vue";
import ProjectExperiencesView from "@/components/views/ProjectExperiencesView.vue";
import CareersView from "@/components/views/CareersView.vue";
import ContactView from "@/components/views/ContactView.vue";
import LeadershipView from "@/components/views/LeadershipView.vue";
import HistoryView from "@/components/views/HistoryView.vue";
import NewsDetailsView from "@/components/views/NewsDetailsView.vue";
import TermsConditionsView from "@/components/views/TermsConditionsView.vue";
import PrivacyPolicyView from "@/components/views/PrivacyPolicyView.vue";
import ProjectDetailsView from "@/components/views/ProjectDetailsView.vue";
import PreviewBannerView from "../views/PreviewBannerView.vue";
import PreviewLayout from "../layouts/PreviewLayout.vue";
import { getGeneral } from '@/services/generalService'

const routes = [
  {
    path: "/",
    component: DefaultLayout,
    children: [
      {
        path: "",
        name: "Home",
        component: HomeView,
        meta: { title: "Home" }
      },
      // {
      //   path: "preview-banner/details/:slug",
      //   name: "PreviewBanner",
      //   props: true,
      //   component: PreviewBannerView,
      //   meta: { title: "Preview Banner" }
      // },
      {
        path: "about-us",
        name: "AboutUs",
        component: AboutUsView,
        meta: { title: "Who We Are" }
      },
      {
        path: "vision-mission",
        name: "VisionMission",
        component: VisionMissionView,
        meta: { title: "Vision & Mission" }
      },
      {
        path: "our-services",
        name: "OurServices",
        component: OurServicesView,
        meta: { title: "Our Services" }
      },
      {
        path: "our-services/category/:catSlug",
        name: "ServicesDetail",
        component: ServicesDetailsView,
        props: true,
        meta: { title: "Service Detail" }
      },
      {
        path: "our-services/details/:catSlug/:subCatSlug",
        name: "ServicesCategoryDetail",
        component: ServicesSubCategoryDetailsView,
        props: true,
        meta: { title: "Service Sub Category Detail" }
      },
      {
        path: "projects",
        name: "Projects",
        component: ProjectsView,
        meta: { title: "Ongoing Projects" }
      },
      {
        path: "project-experiences",
        name: "ProjectExperiences",
        component: ProjectExperiencesView,
        meta: { title: "Our Experiences" }
      },
      {
        path: "projects/details/:slug",
        name: "ProjectDetails",
        component: ProjectDetailsView,
        props: true,
        meta: { title: "Project Details" }
      },
      {
        path: "news",
        name: "News",
        component: NewsView,
        meta: { title: "News" }
      },
      {
        path: "news/details/:slug",
        name: "NewsDetails",
        component: NewsDetailsView,
        props: true,
        meta: { title: "News Details" }
      },
      {
        path: "careers",
        name: "Careers",
        component: CareersView,
        meta: { title: "Careers" }
      },
      {
        path: "contact",
        name: "Contact",
        component: ContactView,
        meta: { title: "Contact" }
      },
      {
        path: "leadership",
        name: "Leadership",
        component: LeadershipView,
        meta: { title: "Leadership" }
      },
      {
        path: "history",
        name: "History",
        component: HistoryView,
        meta: { title: "History" }
      },
      {
        path: "terms-and-conditions",
        name: "TermsConditions",
        component: TermsConditionsView,
        meta: { title: "Terms and Conditions" }
      },
      {
        path: "privacy-policy",
        name: "PrivacyPolicy",
        component: PrivacyPolicyView,
        meta: { title: "Privacy Policy" }
      }
    ]
  },
  {
    path: "/",
    component: PreviewLayout,
    children: [
      {
        path: "preview-banner/details/:slug",
        name: "PreviewBanner",
        props: true,
        component: PreviewBannerView,
        meta: { title: "Preview Banner" }
      }
    ]
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// router.beforeEach((to, from, next) => {
//   document.title = to.meta?.title;
//   next();
// });

router.afterEach(async(to) => {
  try {
    const general = await getGeneral();
    console.log(general)

    const siteTitle = general.name || "PT Kogas Driyap Consultant";

    if (to.meta.title) {
      document.title = `${siteTitle} | ${to.meta.title}`;
    } else {
      document.title = siteTitle;
    }
  } catch (error) {
    console.error(error);

    document.title = to.meta.title
      ? `PT Kogas Driyap Consultant | ${to.meta.title}`
      : "PT Kogas Driyap Consultant";
  }
});

export default router;